import { Box } from '@mui/material';
import { FunctionComponent, PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  title: string;
}

export const DashboardCard: FunctionComponent<Props> = ({ children, title }) => {
  return <Box sx={{ boxShadow: '0px 2px 4px 0px #00000024', p: 3, borderRadius: '0.5rem', height: '100%' }}>
    <Box sx={{ fontSize: '1.25rem', fontWeight: 700, mb: 3 }}>{title}</Box>
    <Box>
      {children}
    </Box>
  </Box>;
};
